/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Modal } from '~/shared/components';
import { Theme } from '~/styles';
import {
  ContentText,
  EvidenceText,
  FooterButtonContainer,
  IconContainer,
  LoadingDataContainer,
  LoadingDataContent,
  LoadingText,
  MevoPrivatePolicyLink,
  Separator,
  ShareDataContainer,
  SharedDataContent,
  Title,
} from './styles';
import ReactLoaderSpinner from 'react-loader-spinner';

const MevoModal = ({ show = false, onConfirm, onClose }) => {
  const [confirmed, setConfirmed] = React.useState(false);
  return (
    <Modal
      isOpen={show}
      heightContainer="700px"
      widthContainer="380px"
      onCloseRequest={() => {
        setConfirmed(false);
        onClose();
      }}
    >
      {confirmed ? (
        <LoadingDataContainer>
          <LoadingDataContent>
            <ReactLoaderSpinner
              type="Oval"
              color="#2493EB"
              height={90}
              width={90}
              loading
            />
            <br />
            <br />
            <LoadingText>Redirecionando para a plataforma Mevo</LoadingText>
          </LoadingDataContent>
          <FooterButtonContainer>
            <Button
              variant="outlined"
              style={{ width: '320px' }}
              margin={`${Theme.spacing.base} 0 ${Theme.spacing.base} 0`}
              onClick={() => {
                setConfirmed(false);
                onClose();
              }}
            >
              <span>Cancelar</span>
            </Button>
          </FooterButtonContainer>
        </LoadingDataContainer>
      ) : (
        <ShareDataContainer>
          <Title>Compartilhamento de dados</Title>
          <IconContainer>
            <Icon data-testid="icon" name="share_info" size="52px" />
          </IconContainer>
          <SharedDataContent>
            <ContentText>
              Pensando na experiência do paciente apresentamos a Mevo, uma
              plataforma que auxilia na{' '}
            </ContentText>
            <EvidenceText>compra de medicamentos 100% digital.</EvidenceText>
            <br /> <br />
            <ContentText>
              Ao optar pela utilização desse serviço, você será direcionado para
              a plataforma da Mevo, bem como concorda em compartilhar os dados
              da sua receita com a mesma.
            </ContentText>
            <br /> <br />
            <ContentText>Informamos que o</ContentText>
            <EvidenceText> Verifica Einstein </EvidenceText>
            <ContentText>
              não está vinculado à utilização da plataforma Mevo, sendo
              totalmente opcional o seu uso.
            </ContentText>
          </SharedDataContent>
          <Separator />
          <MevoPrivatePolicyLink
            href="https://mevosaude.com.br/Politica_de_Privacidade_Mevo_20230313.pdf"
            target="_blank"
          >
            {' '}
            Acessar a política de privacidade da Mevo
          </MevoPrivatePolicyLink>
          <FooterButtonContainer>
            <Button
              style={{ width: '320px' }}
              margin={`${Theme.spacing.base} 0 ${Theme.spacing.base} 0`}
              onClick={() => {
                setConfirmed(true);
                onConfirm()
                  .then((data) => {
                    globalThis.open(data.data.patientUrl);
                    globalThis.location.reload();
                    setConfirmed(false);
                    onClose();
                  })
                  .catch((error_) => {
                    setConfirmed(false);
                    onClose();
                  });
              }}
            >
              <span>Aceito</span>
            </Button>
            <Button
              variant="outlined"
              style={{ width: '320px' }}
              margin={`${Theme.spacing.base} 0 ${Theme.spacing.base} 0`}
              onClick={onClose}
            >
              <span>Não aceito</span>
            </Button>
          </FooterButtonContainer>
        </ShareDataContainer>
      )}
    </Modal>
  );
};

MevoModal.propTypes = {
  show: PropTypes.bool,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
};

MevoModal.defaultProps = {
  show: false,
  onConfirm: () => {},
  onClose: () => {},
};

export default MevoModal;
